export default __webpack_public_path__ + "static/media/calconvert_s2.94256ab2.png";